export class TakeNativeSnapshotRequest {
    'retentionDays';
    'targetRegion';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeNativeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
